define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/action/Popup"
], function(array,declare,domClass,Popup) {

	return declare(Popup, {
		toHtmlWithAccess: function(/*Context*/ctx, /*DOMNode*/refNode) {
			// summary: render red X if style out of sync with theme
			var	e = this.inherited(arguments);
			if (!e) return e;

			var	style = ctx.getNode();
			var	theme = ctx.getParent();
			if (!theme) return e;

			var	a = array.map(ctx.cache.getNodes(theme.ColorColorways), function(ccc) { return ccc && ccc.Available ? ccc.Actual : ""; });
			var	b = array.some(ctx.cache.getNodes(style.ProductColors), function(c) {
				return c.Active && (array.indexOf(a, c.ColorSpecification) < 0);
			});

			if (b) {
				domClass.remove(e, "iconEditColorway");
				domClass.add(e, "iconFixColorway");
			}

			return e;
		}
	});
});